export function isString(data: unknown): boolean {
  return typeof data === 'string';
}

export function isNumber(data: unknown): boolean {
  return typeof data === 'number';
}
